// This import cannot be shortened without creating circular dependencies.
import { WithFillerNodeModelForm } from '@app/page-components/app/canvas/node-forms';
import {
  DesignModuleNodeProps,
  IconClass,
  NodeTypeName,
  WithFillerObjectConfig
} from '@app/types';
import BaseNodeModel from '../BaseNodeModel';

export class WithFillerNodeModel extends BaseNodeModel<WithFillerObjectConfig> {
  constructor(
    nodeName = 'WITH_FILLER_UNTITLED',
    x = 0,
    y = 0,
    props: DesignModuleNodeProps<WithFillerObjectConfig> | null = null,
    id = null
  ) {
    super(nodeName, x, y, null, id);
    this.props.colorClass = 'brown';
    this.props.iconClass = IconClass.codepen;
    this.props.nodeTypeName = NodeTypeName.withFiller;
    this.DEFAULT_COLOR_CLASS = 'brown';
    this.applyProps(props);
  }

  getConfigViews() {
    return [
      <WithFillerNodeModelForm key="form" object={this} />
    ];
  }
}
